import Button from "@app/components/button";
import { FormControl } from "@app/components/form-control";
import Input from "@app/components/input";
import { addToast } from "@app/components/toast/toast.service";
import { RoutePath } from "@app/constants";
import BookTimeFrameService from "@app/services/http/book-time-frame.service";
import {
  BookTimeFrameCreate,
} from "@app/types/book-time-frame.type";
import { createBookTimeFrameValidationSchema } from "@app/validations";
import { Form, Formik, FormikContextType } from "formik";
import { createRef, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface FormValues {
  startTime: string;
  endTime: string;
  bookIds: string;
}

const UpdateBookTimePage = () => {
  const navigate = useNavigate();
  const { bookTimeId } = useParams<{ bookTimeId: string }>();
  const formRef = createRef<FormikContextType<FormValues>>();

  const [initialValues, setInitialValues] = useState<FormValues | null>(null);

  useEffect(() => {
    if (bookTimeId) {
      BookTimeFrameService.get(Number(bookTimeId))
        .then((res) => {
          const { startTime, endTime, bookIds } = res.data;

          setInitialValues({
            startTime,
            endTime,
            bookIds,
          });
        })
        .catch(() => {
          addToast({
            text: "Không thể tải dữ liệu khung giờ.",
            status: "inValid",
          });
          navigate(`/${RoutePath.BOOK_TIME_MANAGEMENT}`);
        });
    }
  }, [bookTimeId, navigate]);

  const handleSubmit = async (values: FormValues) => {
    if (!bookTimeId) return;

    try {
      const bookTimeFrameData: BookTimeFrameCreate = {
        startTime: values.startTime,
        endTime: values.endTime,
        bookIds: values.bookIds.trim(),
      };

      await BookTimeFrameService.update(Number(bookTimeId), bookTimeFrameData);

      addToast({
        text: "Cập nhật khung giờ thành công!",
        status: "valid",
      });

      navigate(`/${RoutePath.BOOK_TIME_MANAGEMENT}`);
    } catch (error) {
      addToast({
        text: "Có lỗi xảy ra khi cập nhật khung giờ!",
        status: "inValid",
      });
    }
  };

  const handleCancel = () => {
    navigate(`/${RoutePath.BOOK_TIME_MANAGEMENT}`);
  };

  if (!initialValues) {
    return (
      <div className="py-6 px-12">
        <div className="flex justify-between items-center">
          <div className="text-[#343C6A]">
            Danh sách cài đặt khung giờ / Sửa
          </div>
        </div>
        <div className="mt-6 rounded-xl bg-white py-6 min-h-[60vh] px-5 flex justify-center items-center">
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="py-6 px-12">
      <div className="flex justify-between items-center">
        <div className="text-[#343C6A]">Danh sách cài đặt khung giờ / Sửa</div>
      </div>

      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validationSchema={createBookTimeFrameValidationSchema}
        validateOnChange
        validateOnBlur
      >
        <Form>
          <div className="mt-6 rounded-xl bg-white py-6 min-h-[60vh] px-5">
            <div className="w-[100%] max-w-[500px] space-y-6">
              <div className="flex gap-4">
                <div className="w-[48%]">
                  <FormControl name="startTime">
                    <Input
                      type="time"
                      className="mt-7"
                    />
                  </FormControl>
                </div>
                <div className="w-[48%]">
                  <FormControl name="endTime">
                    <Input
                      type="time"
                      className="mt-7"
                    />
                  </FormControl>
                </div>
              </div>

              <FormControl name="bookIds">
                <Input className="mt-7" placeholder="ID Sách" />
              </FormControl>
            </div>
          </div>
          <div className="mt-8 flex gap-4">
            <Button
              type="submit"
              size="l"
              label="Lưu"
              width={160}
              className="!h-[51px] !leading-[51px]"
              labelClassName="text-xl"
            />
            <Button
              type="button"
              size="l"
              label="Hủy"
              theme="secondary"
              width={160}
              className="!h-[51px] !leading-[51px]"
              labelClassName="text-xl"
              onClick={handleCancel}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default UpdateBookTimePage;
